import React from 'react'

// Material UI
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Skeleton } from '@mui/material';

//Styles
import './PaymentsBillsToPayComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';

// Components
import TableComponent from 'shared/components/dynamic-table/TableComponent';

// Moment
import * as moment from 'moment';
// Locale
import 'moment/locale/en-au';
import 'moment/locale/es';

//Assets
import payment_icon from 'assets/images/payment_icon.png';

function PaymentsBillsToPayComponent(props) {

    const [selectedTab, setSelectedTab] = React.useState(0);

    const formatData = ( payments) => {
        let new_payments = [];
        payments?.map(payment =>    
            new_payments.push({
                id: payment.id,
                payment_type: payment.payment_type,
                payment_state: payment.payment_state,
                payment_name: payment.caption,
                payment: `<div class="payments-bills-to-pay__tornament"><img src="${payment_icon}"/><div><div class="baloa-names">${payment.caption}</div><div class="payments-bills-to-pay__tornament-cuotas"><div class="baloa-username ${payment.payment_type}">${props.t('tournamentPayments.payment_types.' + payment.payment_type)}</div>${payment.payment_type === 'Payment_In_Installments'? `<div class="baloa-username parcial">${props.t('tournamentPayments.paymentOfLbl',{__complete: payment.complete_installments, __total: payment.installments})} </div>` :''}</div></div></div>`, 
                limit_date: `<div class="baloa-names">${moment(payment.next_deadline).format('LL')}</div>`,
                status: `<div class="payments-bills-to-pay__tornament-state baloa-names ${payment.payment_state}">${props.t('tournamentPayments.payment_states.' + payment.payment_state)}</div>`, 
                value: `<div class="baloa-names">${payment.next_payment}</div>`
            })
        );
        return new_payments;
    }


    return (
        <div className='payments-bills-to-pay__container'>
            <div className='baloa-normal-medium'>{props.t('accountsPayableTabTitle')}</div>
            <Tabs
                //variant="fullWidth"
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(ev, new_value) => {
                    setSelectedTab(new_value);
                    switch (new_value) {                            
                        case 0:
                            props.loadPagePayments( '' );
                            break;
                        case 1://Pendientes
                            props.loadPagePayments( "Pending" );
                            break;
                        case 2://Parciales
                            props.loadPagePayments( "Partial_Payment" );
                            break;
                        case 3://Realizados
                            props.loadPagePayments( "Success" );
                            break;
                            
                        // no default
                    }   
                }}
                aria-label="Selection between "
            >
                <Tab label={props.t("tournamentPayments.allLbl")} />
                <Tab label={props.t("tournamentPayments.pendingLbl")} />
                <Tab label={props.t("tournamentPayments.partialLbl")} />
                <Tab label={props.t("tournamentPayments.successLbl")} />
            </Tabs>

            <div className='payments-bills-to-pay__tab'>
                <TableComponent
                    rows = { formatData(props.page_payments_list)}
                    columns = { [
                        "payment",
                        "limit_date",
                        "status",
                        "value"                       
                    ] }
                    columns_headers = { [            
                        props.t('tournamentPayments.nameColumnLbl'),
                        props.t('tournamentPayments.nextDateLimitColumnLbl'),
                        props.t('tournamentPayments.stateColumnLbl'),
                        props.t('tournamentPayments.valueColumnLbl'),
                    ] }
                    has_image_column = { false }
                    image_column = { -1 }
                    rows_per_page = { 10 }
                    pagination = { true }
                    link_row={true}
                    handleOnActionClick = { props.handleOnPayment }
                    action_link={false}
                    action_column = { false }
                    action_modal_buttons = {false}
                    search_by = "payment_name"
                    searchbar_by = "payment_name"
                    order_by = "teamname"
                    placeholder_search_bar = {props.t('tournamentPayments.searchLbl')}
                    has_searchbar = { true }
                    has_add_button = { false }  
                    has_html={true}
                    has_player_column={false}
                    player_column={-1}
                    // has_button_filter = { false }  
                    //add_button_caption = {props.t('añadir staff .....')}                                   
                    // filter_buttons_captions = { [ ] }   
                    // handleOnAddButtonClick = { props.handleOnAddButtonClick } 
                    team = { false }
                    has_team_column={false}
                    team_column={-1}
                    edit_row={false}
                    edit_row_id={-1}
                    msg_empty_table_title={''}
                    msg_empty_table_text={props.t('tournamentPayments.emptyText')}
                    show_loading_skeleton={ props.loading_page_payments }
                    loading_skeleton={
                        [...Array(Number(5))].map((e, i) => 
                            <div className='payments-bills-to-pay__skeleton-row'>
                                
                                <div className='payments-bills-to-pay__skeleton-row__image'>
                                    <Skeleton animation="wave" variant='circular' component={'div'} width='45px' height={'45px'} />
                                    <div className='payments-bills-to-pay__skeleton-row__image-data'>
                                        <Skeleton animation="wave" component={'div'} width='90%' height={'20px'} />
                                        <Skeleton animation="wave" component={'div'} width='70%' height={'15px'} />
                                    </div>                                    
                                </div>
                                
                                <Skeleton animation="wave" component={'div'} width='15%' />
                                <Skeleton animation="wave" component={'div'} width='10%' />
                                <Skeleton animation="wave" component={'div'} width='5%' />
                               
                            </div>
                        )
                    }
                    //itemClicLabel={ props.t('') }
                    action_buttons={ false }
                    //actions_component = { }
        
                />
            </div>   
        </div>
    )
}

export default withTranslation('payments')(PaymentsBillsToPayComponent)